import $ from 'jquery';

export default class Header {
    constructor() {
        this.$header = $('.header');
        this.$hamburger = $('.header-tertiary__hamburger');
        this.$nav = $('.header-primary__nav');
        this.$submenuToggles = $('.sub-menu-toggle');
        this.$weatherTriggers = $('[data-weather-trigger]');
        this.$weatherDialog = $('#weather-dialog');

        this.bind();
    }

    bind() {
        this.$hamburger.on("click", this.toggleMenu.bind(this));
        this.$submenuToggles.on("click", this.toggleSubmenu.bind(this));
        this.$weatherTriggers.on("click", this.openWeather.bind(this));
        this.$weatherDialog.find('[data-weather-close]').on("click", this.closeWeather.bind(this));

        // Close the weather dialog when the backdrop (outside the inner panel)
        // is clicked. <dialog> reports the click target as the dialog itself.
        this.$weatherDialog.on("click", (e) => {
            if (e.target === this.$weatherDialog[0]) {
                this.closeWeather();
            }
        });

        // Close menu on escape key
        $(document).on('keydown', (e) => {
            if (e.key === 'Escape' && this.$nav.hasClass('is-open')) {
                this.toggleMenu();
            }
        });

        // Handle resize events
        let resizeTimer;
        $(window).on('resize', () => {
            $('body').addClass('is-resizing');
            
            if (window.innerWidth >= 1025 && this.$nav.hasClass('is-open')) {
                this.toggleMenu();
            }

            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(() => {
                $('body').removeClass('is-resizing');
            }, 400);
        });
    }

    toggleMenu() {
        const expanded = this.$hamburger.attr('aria-expanded') === 'true';
        this.$hamburger.attr('aria-expanded', !expanded);
        this.$nav.toggleClass('is-open');
        this.$header.toggleClass('is-open');
        $('body').toggleClass('no-scroll', !expanded);
    }

    openWeather() {
        const dialog = this.$weatherDialog[0];
        if (dialog && typeof dialog.showModal === 'function' && !dialog.open) {
            dialog.showModal();
        }
    }

    closeWeather() {
        const dialog = this.$weatherDialog[0];
        if (dialog && dialog.open) {
            dialog.close();
        }
    }

    toggleSubmenu(e) {
        const $toggle = $(e.currentTarget);
        const $menuItem = $toggle.closest('.menu-item');
        const $subMenu = $menuItem.find('> .sub-menu');
        const expanded = $toggle.attr('aria-expanded') === 'true';

        // Accordion behavior: close any other open submenus at the same level
        // (skip the current item and its ancestors so nested menus stay open).
        if (!expanded) {
            $menuItem.siblings('.menu-item')
                .find('.sub-menu-toggle[aria-expanded="true"]')
                .each((_, el) => {
                    const $otherToggle = $(el);
                    $otherToggle.attr('aria-expanded', 'false');
                    $otherToggle.closest('.menu-item')
                        .find('> .sub-menu')
                        .removeClass('is-open')
                        .slideUp(300);
                });
        }

        $toggle.attr('aria-expanded', !expanded);
        $subMenu.toggleClass('is-open').slideToggle(300);
    }
}